export const SEARCH_OMIM_DISEASE =
  'https://ontology.jax.org/api/network/search/disease?q=';

export const FIND_ORPHA_FROM_OMIM =
  'https://api.orphacode.org/EN/ClinicalEntity/FindbyOMIM/';

export const HPO_ANNOTATION_API_URL =
  'https://ontology.jax.org/api/network/annotation/';

export const FIND_ICD10_FROM_ORPHA =
  'https://api.orphacode.org/EN/ClinicalEntity/orphacode/';
